import React from 'react';
import PropsTypes from 'prop-types';
import Box from '@mui/material/Box';

const MediaSlider = ({ children }) => {
  return (
    <Box
      sx={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        padding: 5,
        '& .slick-slider': {
          pb: 0,
        },
        '& .slick-slide': {
          textAlign: 'center',
          position: 'relative',
          '& img': {
            width: 'auto !important',
            maxHeight: '500px',
            height: 'auto !important',
          },
          '& > *': {
            position: 'relative',
            zIndex: 9,
          },
        },
        '& .slick-dots li button:before, & .slick-dots li.slick-active button:before':
        {
          color: 'white',
          fontSize: '16px'
        },
        '& .embed-responsive': {
          position: 'relative',
          display: 'block',
          width: '90% !important',
          height: '85vh',
          padding: 0,
          overflow: 'hidden',
          '&:before': {
            content: '""',
            display: 'block',
          },
          '& embed, & iframe, & object, & video': {
            position: 'absolute',
            top: 0,
            bottom: 0,
            left: 0,
            width: '100%',
            height: '100%',
            border: 0,
            color: 'white',

            '& html, & body, & pre': {
              color: 'white',
            },
          },
        },
        '& .slick-next': {
          right: 0,
          zIndex: 900
        },
        '& .slick-prev': {
          left: 0,
          zIndex: 900
        },
      }}
    >
      {children}
    </Box>
  );
};

export default MediaSlider;

MediaSlider.propTypes = {
  children: PropsTypes.node,
};
